import * as breakpoints from "../breakpoints";
import * as colors from "../constants/colors";
import * as config from "../config";
import browserHistory from "react-router/lib/browserHistory";
import { submitSurvey } from "../api/survey";
import { css, StyleSheet } from "aphrodite";
import { english, spanish } from "../constants/strings";
import * as languages from "../constants/languages";
import CertificateModal from "./CertificateModal";
import { NotificationManager } from "react-notifications";
import PropTypes from "prop-types";
import SurveyQuestion from "./SurveyQuestion";
import React, { PureComponent } from "react";

export const QUESTION_TYPES = {
	MULT_CHOICE: "MULT_CHOICE",
	FREE_RESPONSE_SHORT: "FREE_RESPONSE_SHORT",
};

const styles = StyleSheet.create({
	container: {
		textAlign: "left",
		maxWidth: 580,
		margin: "auto",
	},
	content: {
		"@media print": {
			display: "none",
		},
	},
	noScrollContent: {
		[breakpoints.mobileOnly]: {
			maxHeight: "50vh",
			overflow: "hidden",
		},
	},
	instructions: {
		// maxWidth: 580,
		fontSize: 15,
		lineHeight: 1.33,
		color: colors.black7,
		fontFamily: "freight-sans-pro",
	},
	submitButton: {
		border: `3px solid ${colors.gold2}`,
		color: colors.gold2,
		backgroundColor: colors.white,
		borderRadius: 20,
		paddingTop: 2,
		paddingBottom: 2,
		paddingLeft: 18,
		paddingRight: 18,
		marginTop: 42,
		marginBottom: 24,
		lineHeight: 2,
		fontSize: 15,
		fontFamily: "freight-sans-pro",
		fontWeight: "bold",
		[breakpoints.mobileOnly]: {
			marginBottom: 0,
			marginTop: 56,
		},
		"@media print": {
			display: "none",
		},
	},
	surveyForm: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		paddingLeft: 5,
		paddingRight: 5,
	},
});

export default class CustomerSatisfactionSurvey extends PureComponent {
	static propTypes = {
		certificate: PropTypes.string,
		classId: PropTypes.string.isRequired,
		language: PropTypes.string.isRequired,
		loggedIn: PropTypes.bool.isRequired,
		setModalShowing: PropTypes.func.isRequired,
		sessionId: PropTypes.string,
	};

	constructor(props) {
		super(props);

		this.strings = props.language === languages.es ? spanish : english;

		this.questions = [
			{
				id: 1,
				prompt: this.strings.survey.questions.question1,
				choices: [
					this.strings.survey.answers.extremelyLikely,
					this.strings.survey.answers.somewhatLikely,
					this.strings.survey.answers.neitherLikelyOrUnlikely,
					this.strings.survey.answers.somewhatUnlikely,
					this.strings.survey.answers.extremelyUnlikely,
				],
				questionType: QUESTION_TYPES.MULT_CHOICE,
			},
			{
				id: 2,
				prompt: this.strings.survey.questions.question2,
				choices: [
					this.strings.survey.answers.extremelyLikely,
					this.strings.survey.answers.somewhatLikely,
					this.strings.survey.answers.neitherLikelyOrUnlikely,
					this.strings.survey.answers.somewhatUnlikely,
					this.strings.survey.answers.extremelyUnlikely,
				],
				questionType: QUESTION_TYPES.MULT_CHOICE,
			},
			{
				id: 3,
				prompt: this.strings.survey.questions.question3,
				choices: null,
				questionType: QUESTION_TYPES.FREE_RESPONSE_SHORT,
			},
			{
				id: 4,
				prompt: this.strings.survey.questions.question4,
				choices: null,
				questionType: QUESTION_TYPES.FREE_RESPONSE_SHORT,
			},
		];

		this.state = {
			answers: {},
			showCertificate: false,
		};
	}

	_answerQuestion = (q, a) => {
		this.setState({
			answers: {
				...this.state.answers,
				[`q${q.id}`]: a,
			},
		});
	};

	_hideCertificate = () => {
		this.setState(
			{
				showCertificate: false,
			},
			() => {
				this.props.setModalShowing(false);
			},
		);

		let destination;
		if (this.props.loggedIn) {
			if (this.props.language) {
				destination = `/catalog?language=${this.props.language}`;
			} else {
				destination = "/catalog";
			}
		} else {
			destination =
				config.drupalSiteUrl +
				(this.props.language === languages.es ? "/es/clases-en-linea" : "/online-classes");
		}

		window.location.href = destination;
	};

	_submitForm = e => {
		e.preventDefault();

		submitSurvey(
			this.props.classId,
			{
				q1: parseInt(this.state.answers.q1, 10),
				q2: parseInt(this.state.answers.q2, 10),
				q3: this.state.answers.q3 || "",
				q4: this.state.answers.q4 || "",
			},
			this.props.language === languages.es ? languages.es : null,
			this.props.sessionId,
		)
			.then(() => {
				this.setState(
					{
						showCertificate: true,
					},
					() => {
						this.props.setModalShowing(true);
					},
				);
			})
			.catch(err => {
				if (!this.props.certificate && err.response && err.response.status === 401) {
					browserHistory.push(
						`/login?redirectpath=${encodeURIComponent(
							`/survey/${this.props.classId}`,
						)}`,
					);
					window.location.reload();
				} else if (err.response && err.response.status === 404) {
					NotificationManager.error(
						"No certificate found. Class may not have been completed",
					);
				} else {
					this.setState(
						{
							showCertificate: true,
						},
						() => {
							this.props.setModalShowing(true);
						},
					);
					// browserHistory.push("/catalog");
					// window.location.reload();
				}
			});
	};

	render() {
		return (
			<div className={css(styles.container)}>
				<div
					className={css(
						this.state.showCertificate
							? [styles.noScrollContent, styles.content]
							: styles.content,
					)}
				>
					<div className={css(styles.instructions)}>
						{this.strings.surveyInstructions}
					</div>
					<form className={css(styles.surveyForm)} onSubmit={this._submitForm}>
						<div>
							{this.questions.map(q => (
								<SurveyQuestion
									key={q.id}
									question={q}
									answerQuestion={this._answerQuestion}
								/>
							))}
						</div>
						<button className={css(styles.submitButton)} type="submit">
							{this.strings.COMPLETE_CLASS}
						</button>
					</form>
				</div>
				<CertificateModal
					showing={this.state.showCertificate}
					dismiss={this._hideCertificate}
					classId={this.props.classId}
					certificate={this.props.certificate}
					language={this.props.language}
				/>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/CustomerSatisfactionSurvey.js